angular
    .module('quattro.bmbo.domain.form', [
        'quattro.core.hpls-api-validation',
        'quattro.core.password-form',
        'quattro.core.user.service',
        'quattro.core.viewhelper',
        'quattro.bmbo.account.select-context',
    ])
    .directive('bmboDomainForm', function () {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                account: '=',
                isCreate: '=?',
                cancel: '=',
                // will be called after successfull validation
                save: '=',
            },
            controller: 'bmboDomainFormController',
            controllerAs: 'vm',
            templateUrl: 'bmbo/domain/domain-form.html',
        };
    })
    .controller('bmboDomainFormController', function ($scope, userService, viewHelper) {

        this.user = userService.scope;

        this.save = function () {
            if (viewHelper.formIsValid()) {
                $scope.save();
            }
        }

        $scope.$watch('data.context_id', function (newValue, oldValue, scope) {
            scope.contextIdIsDirty = scope.data.$isDirty('context_id');
        });

    });
